import '@resources/fontes/fontes.css'
import '@resources/css/report.css'
import Header from '@components/Header/Header'
import Sidebar from '@components/Sidebar/Sidebar'
import LoadingSpinner from '@components/LoadingSpinner/LoadingSpinner'
import React, { useContext, useEffect, useState, useMemo, useCallback } from 'react'
import CardSample from '@components/Cards/CardSample/CardSample'
import { BsChevronRight } from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import IDonor from '@interfaces/IDonor'
import * as $Donor from '@services/Donor'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Card } from 'react-bootstrap'
import AuthContext from '@contexts/Auth'

const Favorites: React.FC<any> = () => {
  const { user, onFavoriteDonor, onAddDonorToCart, cart, setCartCount } = useContext(AuthContext)

  const [donors, setDonors] = useState<IDonor[]>([])
  const [cartDonorIds, setCartDonorIds] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [addingToCart, setAddingToCart] = useState<string[]>([])

  const navigate = useNavigate()

  const SweetAlert = useMemo(() => withReactContent(Swal), [])

  const isPatient = user?.roles?.some((role: any) => role.name === 'Paciente')

  const fetchFavorites = useCallback(() => {
    setIsLoading(true)
    return $Donor.favorites().then(({ data: favorites }) => {
      setDonors(favorites)

      // Update cart count when fetching favorites
      if (cart?.donor_ids) {
        const ids = cart.donor_ids.split(' / ').filter(Boolean)
        setCartCount(ids.length)
      }
    }).catch((error) => {
      SweetAlert.fire('Erro', error.message || 'Erro ao buscar doadores favoritos', 'error')
      navigate('/')
    }).finally(() => {
      setIsLoading(false)
    })
  }, [navigate, SweetAlert, cart, setCartCount])

  useEffect(() => {
    fetchFavorites()
  }, [fetchFavorites])

  useEffect(() => {
    const handleFocus = () => {
      fetchFavorites()
    }

    window.addEventListener('focus', handleFocus)

    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  }, [fetchFavorites])

  useEffect(() => {
    if (cart?.donor_ids) {
      const ids = cart.donor_ids.split(' / ').filter(Boolean)
      setCartDonorIds(ids)
    }
  }, [cart])

  const handleUnfavorite = (id: string) => {
    onFavoriteDonor(id, () => {
      setDonors((prevDonors) => prevDonors.filter((donor) => donor.internal_id !== id))
    })
  }

  const handleAddToCart = async (id: string) => {
    if (addingToCart.includes(id)) return
    setAddingToCart(prev => [...prev, id])
    try {
      await onAddDonorToCart(id, (success) => {
        if (success) {
          setCartDonorIds((prevIds) => [...prevIds, id])
        }
      })
    } finally {
      setAddingToCart(prev => prev.filter(i => i !== id))
    }
  }

  return (
    <div className="favorites d-lg-flex justify-content-lg-center">
      <Sidebar />
      <main className="with-fixed-nav">
        <LoadingSpinner isLoading={isLoading} text="Carregando favoritos..." />
        <Header showSidebarOpenButton />
        <div className="row mt-4">
          <div className="col-auto pr-0">
            <Link to="/" className="text-body d-flex align-items-center">Catálogo</Link>
          </div>
          <div className="col-auto pl-1 pr-1">
            <BsChevronRight size={10} />
          </div>
          <div className="col-auto p-0">
            <a href="#" className="id d-flex align-items-center font-weight-bold">
              Favoritos
            </a>
          </div>
        </div>
        <div className="row mb-3">
          <Card className="w-100 p-4 border-0 shadow-sm rounded-30 mt-5">
            <p className="mb-0">
              Aqui estão os doadores que você mais gostou e favoritou!
            </p>
            <p className="mb-0">
              Lembre-se que a disponibilidade das amostras de sêmen pode mudar a qualquer momento 😉
            </p>
            <p className="mb-0">
              Para garantir amostras de sêmen do seu doador preferido, <b>adicione ele ao carrinho</b> e solicite a reserva através da aba “Carrinho”!
            </p>
            <p className="m-0">
              Se precisar de ajuda, nos chame <b>pelo nosso WhatsApp de atendimento personalizado!</b>
            </p>
          </Card>
        </div>
        <div className="row mb-4">
          {donors.map((donor) => (
            <div className="col-12 col-md-4 col-xl-3 px-0 px-md-3" key={donor.id}>
              <CardSample
                donor={donor}
                handleUnfavorite={handleUnfavorite}
                handleAddToCart={isPatient ? handleAddToCart : undefined}
                cartDonorIds={cartDonorIds}
                addingToCart={addingToCart}
              />
            </div>
          ))}
        </div>
      </main>
    </div>
  )
}

export default Favorites